import styled from "styled-components";
import { device }  from "../utlis/device";

const PointerContainer = styled.div ` 
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  top: 0;
  padding: 80px 0px;
  transition: transform 1.5s;
  transform: rotate(${props => props.rotation});
  z-index: 1;
`

const PointerStyle = styled.img `
  width: 43px;
  @media ${device.mobileL} {
    width: 34px;
    padding: 0px 0px;
  }
  @media ${device.mobileM} {
    width: 30px;
    padding: 0px 0px;
  }
  @media ${device.mobileS} {
    width: 25px;
    padding: 0px 0px;
  }
  @media (max-width: 320px) {
    width: 24px;
  }
  @media (max-width: 280px) {
    width: 24px;
  }
`


function Pointer(props) {
    return (
      <PointerContainer rotation={props.rotation  + "deg"} >
       <PointerStyle src="/images/NiceOmetre-Arrow.png" alt='ometer' width="43px"/>
      </PointerContainer>
    );
  }
  
  export default Pointer;